(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bl-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(bar) {
      if (bar.dataset.blInit) return;
      bar.dataset.blInit = '1';
      var section = bar.closest('.shopify-section') || document;
      var mainBtn = section.querySelector('product-form-component button[name="add"], .buy-buttons-block button[name="add"], form[action*="/cart/add"] button[name="add"]');
      if (!mainBtn) return;
      var btn = bar.querySelector('[data-bl-satc-btn]');
      var price = bar.querySelector('[data-bl-satc-price]');
      var priceSource = section.querySelector('product-price .price, product-price, .price');
      function sync() {
        btn.disabled = mainBtn.disabled;
        btn.textContent = mainBtn.disabled ? (bar.dataset.soldOut || 'Agotado') : (bar.dataset.label || btn.dataset.label || btn.textContent);
        if (price && priceSource) {
          var m = priceSource.textContent.replace(/\s+/g, ' ').match(/\$\s?[\d.,]+/);
          if (m) price.textContent = m[0].replace(/\s/g, '');
        }
      }
      btn.dataset.label = btn.textContent;
      btn.addEventListener('click', function () { mainBtn.click(); });
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var below = e.boundingClientRect.top < 0;
        bar.hidden = e.isIntersecting || !below;
      }, { threshold: 0 });
      io.observe(mainBtn);
      new MutationObserver(sync).observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      document.addEventListener('change', sync);
      sync();
    }
    function boot() { document.querySelectorAll('[data-bl-satc]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
